import '../styles/Introduction.scss';

import { Stack } from '@whistler-ui/k2/components/Stack';
import { Heading, Paragraph } from '@whistler-ui/k2/components/Typography';

import { useRenderIf } from '../../../hooks/useRenderIf';
import { PhaseCard, PhaseStep } from './PhaseCard';

const onboardingStepsUES: PhaseStep[] = [
  { id: 1, label: 'Select use cases' },
  { id: 2, label: 'Implement your APIs' },
  { id: 3, label: 'Test in pre-production' },
  { id: 4, label: 'Upgrade to prod account' },
  { id: 5, label: 'Update GSMA NSX' },
];

const launchStepsUES: PhaseStep[] = [
  { id: 6, label: 'Test in production' },
  { id: 7, label: 'Sign contract' },
  { id: 8, label: 'Complete OEM certification' },
  { id: 9, label: 'Public beta test' },
  { id: 10, label: 'Go live' },
];

const onboardingSteps: PhaseStep[] = [
  { id: 1, label: 'Select use cases' },
  { id: 2, label: 'API integration' },
  { id: 3, label: 'Pre-production validation' },
  { id: 4, label: 'Production validation' },
];

const launchSteps: PhaseStep[] = [
  { id: 5, label: 'Commercial agreement' },
  { id: 6, label: 'Complete OEM certification' },
  { id: 7, label: 'Public beta test' },
  { id: 8, label: 'Go live' },
];

const infoText = [
  [
    `Start by selecting the use cases you want to launch. Baseline and eSIM Transfer are mandatory and must be included.`,
    `Next, implement the required APIs and deploy them in your test or pre-production environment. Use the portal test framework to validate individual APIs and run end-to-end use case tests simulating real iOS and Android devices.`,
    `Once testing is complete, configure your production account, update GSMA NSX, and re-test everything in production.`,
    `You are then ready to begin certification with our certification team. Your account manager will provide a commercial contract, which must be signed before the certification process can start.`,
  ],
  [
    `Start by selecting the use cases you want to launch and notifying your OEM’s carrier team of your scope and target launch window.`,
    `Next, implement the required APIs and deploy them in your test or pre-production environment. Use the portal test framework to validate individual APIs and run end-to-end use case tests simulating real iOS and Android devices.`,
    `Once testing is complete, configure your production account and re-test everything in production.`,
    `You are then ready to begin certification with the OEM’s carrier team. Your account manager will provide a commercial contract, which must be signed before the certification process can start.`,
  ],
];

export function Journey() {
  const { isUES, partnerName } = useRenderIf();

  return (
    <div>
      <Stack direction="row" gap={12}>
        <Stack direction="column" gap={4} className="w-1/3">
          <Heading level={1}>Journey Overview</Heading>
          <Stack direction="column" gap={4}>
            {infoText[isUES ? 0 : 1].map((text, index) => (
              <Paragraph key={index}>{text}</Paragraph>
            ))}
          </Stack>
        </Stack>

        <Stack direction="row" gap={4} className="w-2/3">
          <PhaseCard
            title="Carrier Onboarding"
            subtitle={isUES ? 'Steps 1-5' : 'Steps 1-4'}
            badgeText="Test"
            theme={partnerName}
            steps={isUES ? onboardingStepsUES : onboardingSteps}
          />
          <PhaseCard
            title="Launch Preparation"
            subtitle={isUES ? 'Steps 6-10' : 'Steps 5-8'}
            badgeText="Live"
            theme="live"
            steps={isUES ? launchStepsUES : launchSteps}
          />
        </Stack>
      </Stack>
    </div>
  );
}
